<template>
  <client-only>

    <div :id="searchableId">
  
      <PostHeaderSmall :model="model" :post="element" :showChat="showChat" />

      <PostCarousel 
        v-if="isCarousel"
        :postData="postData"
        :postContent="postContent"
        :model="model"
        :VideoElementHandler="VideoElementHandler"
      />
      <PostSimple 
        v-else
        :postData="postData"
        :postContent="postContentSimple"
        :model="model"
        :VideoElementHandler="VideoElementHandler"
      />

      <PostDescription :post="element" :model="model" />
    </div>

  </client-only>
</template>

<script setup lang="ts">
import { Post } from '~/types/Post';

interface _Props {
  element: Post;
  model?: any;
  showChat?: boolean;
};

const { 
  element, 
  model,
  showChat,
}: _Props = withDefaults(defineProps<_Props>(), {
  model: {},
  showChat: false,
});

const isCarousel = computed(() => {
  return element && element.content && element.content.length > 1;
});

const postContent = computed(() => {
  if (element.content) {
    return element.content;
  }

  return element;
});

const postData = computed(() => {
  // Duplicate thos.element
  const data = { ...element };

  if (data.content) {
    if (data.content.length) {
      data.qElements = data.content.length;
    } else {
      data.qElements = 1;
    }

    delete data.content;
  }

  return data;
});

const postContentSimple = computed(() => {
  const data = element.content;

  if (data) {
    return data[0];
  }

  return element;
});

const VideoElementHandler = computed(() => {
  const instance = getCurrentInstance();
  let elem = instance;

  const functionsNeeded = ["videoAppendHandler", "videoHardAppendHandler", "videoRemoveHandler", "videoMuteHandler"];

  /**
   * No pude hacer que funcione instance.parent, por eso uso un while hasta que encuentre lo que busco
   */
  while (elem) {
    if (elem.exposed) {
      const keys = Object.keys(elem.exposed);

      if (keys.length) {
        const hasFunctions = functionsNeeded.every((fn) => keys.includes(fn));

        if (hasFunctions) return elem.exposed;
      }
    }

    elem = elem.parent;
  }

  return elem;
});

const searchableId = computed(() => {
  return `post-${element.post_id}`;
});
</script>

<style lang="scss" scoped>
.post-container {
  max-width: 100%;
  max-height: 90vh;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
}
</style>
